import { Component, inject, OnInit } from '@angular/core';
import { DecimalPipe, NgComponentOutlet } from '@angular/common';
import { ApiEnvNames, API_STATUS } from '../../../model/api.model';
import { fetchParamsEventListForDashboard, RegistrationHeaderCard, RegistrationTitle } from '../../../model/event-registration.model';
import { CommonService } from '../../../services/common.service';
import { CommonUtils } from '../../../utils/common.utils';
import { EventTabMainComponent } from '../event-tab-main/event-tab-main.component';
import { LoadingSkeletonComponent } from "../../../layout/loading-skeleton/loading-skeleton.component";

@Component({
  selector: 'app-registration-dashboard',
  standalone: true,
  imports: [NgComponentOutlet, DecimalPipe, LoadingSkeletonComponent],
  templateUrl: './event-registration-dashboard.component.html',
  styleUrl: './event-registration-dashboard.component.scss'
})
export class EventRegistrationDashboardComponent implements OnInit {
  private readonly allStatuses: Array<RegistrationHeaderCard['status']> = ['Active', 'Upcoming', 'Completed'];
  private readonly commonService = inject(CommonService);
  private readonly commonUtils = inject(CommonUtils);
  title: string = RegistrationTitle;
  headerCards: Array<RegistrationHeaderCard> = [];
  showDashboard = false;
  selectedHeader = '';
  selectedFilters: Array<RegistrationHeaderCard['status']> = ['Active'];
  searchTerm = '';
  selectedEvent!: any;
  readonly eventTabMainComponent = EventTabMainComponent;
  isLoading = false;
  ngOnInit(): void {
    this.fetchEventListForDashboard();
  }
  fetchEventListForDashboard() {
    this.isLoading = true;

    this.commonService.getDataFromDataSource(fetchParamsEventListForDashboard, ApiEnvNames['EventDashboard'])
      .then((response: { status: string; result?: any[] }) => {
        if (response.status === API_STATUS.Success && response.result) {
          this.headerCards = response.result;
        }
      })
      .catch((error: Error) => {
        console.info('Error fetching event list for dashboard:', error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }

  get filteredCards(): Array<RegistrationHeaderCard> {
    const normalizedSearch = this.searchTerm.trim().toLowerCase();

    return this.headerCards.filter(card => {
      const matchesStatus = this.selectedFilters.includes(card.status);
      const matchesSearch = !normalizedSearch || card.event_name.toLowerCase().includes(normalizedSearch);

      return matchesStatus && matchesSearch;
    });
  }

  get displayedEventsCount(): number {
    return this.filteredCards.length;
  }

  get totalEventsCount(): number {
    return this.headerCards.length;
  }

  toggleFilter(filter: RegistrationHeaderCard['status']) {
    if (this.selectedFilters.includes(filter)) {
      this.selectedFilters = this.selectedFilters.filter(current => current !== filter);
      return;
    }

    const next = new Set([...this.selectedFilters, filter]);
    this.selectedFilters = this.allStatuses.filter(status => next.has(status));
  }

  isFilterSelected(filter: RegistrationHeaderCard['status']): boolean {
    return this.selectedFilters.includes(filter);
  }

  onSearchChange(value: string) {
    this.searchTerm = value;
  }

  openEvent(card: any) {
    this.selectedHeader = card.event_name;
    this.selectedEvent = card;
    this.showDashboard = true;
  }

  backToHeaders() {
    this.showDashboard = false;
  }
  get eventTabInputs() {
    return {
      event: this.selectedEvent,
      backFuncCall: this.backToHeaders.bind(this)
    };
  }

  getStatusColor(status: string): string {
    switch (status) {
      case 'Active': return '#4CAF50';
      case 'Upcoming': return '#2196F3';
      case 'Completed': return '#8BC34A';
      default: return '#999';
    }
  }
}
